import _ from 'underscore';
import BasicSequencerNodeInspectorView from "views/audioEditor/sequencerNodeInspectorSection/BasicSequencerNodeInspectorView";
import WordParamView from "views/audioEditor/sequencerNodeInspectorSection/paramView/WordParamView";
import ParagraphParamView from "views/audioEditor/sequencerNodeInspectorSection/paramView/ParagraphParamView";
import TitleParamView from "views/audioEditor/sequencerNodeInspectorSection/paramView/TitleParamView";
import SubTitleParamView from "views/audioEditor/sequencerNodeInspectorSection/paramView/SubTitleParamView";
import Utils from 'models/helper/Utils';
import InfoBoxView from "views/common/InfoBoxView";
import DeletionSource from 'models/audioEditor/DeletionSource';
import ti18n from 'i18n!nls/Sequenceri18n';


const SEARCH_QUERY_PRESET_I18N_PREFIX = "AI_SEARCH_QUERY_PRESET_";
const AI_SEARCH_RESULT_CONFIDENCE_LEVEL_PREFIX = "AI_SEARCH_RESULT_CONFIDENCE_LEVEL_";
const AGENT_EDITING_SESSION_DEFAULT_REASON = "agentEditingSession";
const AGENT_DELETION_CATEGORY_FILLER = "filler";
const DeletedSequencerNodeInspectorView = BasicSequencerNodeInspectorView.extend({


    constructor : function(attributes, options) {
        BasicSequencerNodeInspectorView.apply(this, [attributes, options]);
        this._numberOfElementsSelected =  attributes.numberOfElementsSelected;

    },

    listenToChangeEventsOnModel :function(){

    },

    getCustomCssClass : function(){
        return "deleted_content_inpector_container";
    },

    _isAgentDeletionSource : function(deletionSource){
        return deletionSource && (
            deletionSource.getType() === Utils.getInstance().getDeletionSourceType().MCP ||
            deletionSource.getSource() === DeletionSource.SOURCE.MCP_AGENT
        );
    },

    _getSourceLabelFromDeletionSource : function(){
        const deletionSource = this.getSequencerNode().getDeletionSource();
        if(deletionSource){
            if(this._isAgentDeletionSource(deletionSource)){
                return window.getI18n(ti18n, "AI_AGENT");
            }
            switch(deletionSource.getType()){
                case Utils.getInstance().getDeletionSourceType().AI_EDIT_SUGGESTION_SEARCH:
                    return window.getI18n(ti18n, "AI_EDIT_SUGGESTIONS");
                case Utils.getInstance().getDeletionSourceType().TEXT_SEARCH:
                    return  window.getI18n(ti18n, "TEXT_SEARCH");
                case Utils.getInstance().getDeletionSourceType().DISFLUENCY_SEARCH:
                    return  window.getI18n(ti18n, "DISFLUENCY_SEARCH");
                case Utils.getInstance().getDeletionSourceType().FILLER_WORD_SEARCH:
                    return  window.getI18n(ti18n, "FILLER_WORD_SEARCH");
                case Utils.getInstance().getDeletionSourceType().SILENCE_SEARCH:
                    return  window.getI18n(ti18n, "SILENCE_SEARCH");
                case Utils.getInstance().getDeletionSourceType().DEFAULT:
                    return  window.getI18n(ti18n, "DEFAULT");
                default: 
                    return  window.getI18n(ti18n, "DEFAULT");
            }
        }else{
            return null;
        }
    },

    _formatAgentDeletionCategory : function(category){
        if(!category){
            return null;
        }
        return `${category}`.split(/[_-]+/).filter(function(categoryPart){
            return categoryPart;
        }).map(function(categoryPart){
            return categoryPart.charAt(0).toUpperCase() + categoryPart.slice(1);
        }).join(" ");
    },

    _isLegacyBulkMcpFillerDeletionSource : function(deletionSource){
        return deletionSource &&
            deletionSource.getType() === Utils.getInstance().getDeletionSourceType().MCP &&
            deletionSource.getAppliedInBulk() &&
            !deletionSource.getCategory() &&
            !deletionSource.getReason();
    },

    _getAgentDeletionCategory : function(deletionSource){
        return deletionSource.getCategory() || (this._isLegacyBulkMcpFillerDeletionSource(deletionSource) ? AGENT_DELETION_CATEGORY_FILLER : null);
    },

    _getUsefulAgentDeletionReason : function(deletionSource){
        const reason = deletionSource.getReason();
        if(reason && reason !== AGENT_EDITING_SESSION_DEFAULT_REASON){
            return reason;
        }
        if(this._isLegacyBulkMcpFillerDeletionSource(deletionSource)){
            return window.getI18n(ti18n, "MCP_AGENT_LEGACY_FILLER_WORD_REASON");
        }
        return null;
    },

    _addAgentDeletionDetailsParamViews : function(paramViewArray, deletionSource){
        const categoryLabel = this._formatAgentDeletionCategory(this._getAgentDeletionCategory(deletionSource));
        if(categoryLabel){
            const agentCategoryParamView =  new WordParamView();
            agentCategoryParamView.setLabel(window.getI18n(ti18n, "TYPE") +": ");
            agentCategoryParamView.setValue(_.escape(categoryLabel));
            agentCategoryParamView.render();
            paramViewArray.push(agentCategoryParamView);
        }

        const usefulReason = this._getUsefulAgentDeletionReason(deletionSource);
        if(usefulReason){
            const agentReasonParamView =  new ParagraphParamView();
            agentReasonParamView.setLabel(window.getI18n(ti18n, "REASON") +": ");
            agentReasonParamView.setValue(_.escape(Utils.getInstance().removeWordIdsFromTranscription(usefulReason)));
            agentReasonParamView.render();
            paramViewArray.push(agentReasonParamView);
        }
    },

    getSearchQueryPresetTypeLabel : function(searchPresetEnumValue){
        const label =  window.getI18n(ti18n, SEARCH_QUERY_PRESET_I18N_PREFIX+ searchPresetEnumValue);
        return label? label : searchPresetEnumValue;
    },

    getSearchResultConfidenceLevelLabel : function(confidenceLevelEnumValue){
        return window.getI18n(ti18n, AI_SEARCH_RESULT_CONFIDENCE_LEVEL_PREFIX+ confidenceLevelEnumValue.toUpperCase());
    },



    renderAllParamViews : function(){
        const paramViewArray  = [];
        if(this.getSequencerNode().getDeletionSource()){
            const deletionSource = this.getSequencerNode().getDeletionSource();
            const titleParamView =  new TitleParamView();
            titleParamView.setValue(window.getI18n(ti18n, "DELETED_CONTENT"));
            titleParamView.render();
            paramViewArray.push(titleParamView);
            const wordParamView =  new WordParamView();
            wordParamView.setLabel(window.getI18n(ti18n, "SOURCE") +": ");
            wordParamView.setValue(this._getSourceLabelFromDeletionSource());
            wordParamView.render();
            paramViewArray.push(wordParamView);
            const appliedInBulkParamView =  new WordParamView();
            appliedInBulkParamView.setLabel(window.getI18n(ti18n, "APPLIED_IN_BULK") +": ");
            appliedInBulkParamView.setValue(deletionSource.getAppliedInBulk()?window.getI18n(ti18n, "YES"): window.getI18n(ti18n, "NO"));
            appliedInBulkParamView.render();
            paramViewArray.push(appliedInBulkParamView);
            if(this._isAgentDeletionSource(deletionSource)){
                this._addAgentDeletionDetailsParamViews(paramViewArray, deletionSource);
            }
            if(Utils.getInstance().isInstanceOfAISuggestionDeletionSource(deletionSource)){
                const detailsParamView =  new SubTitleParamView();
                detailsParamView.setValue(window.getI18n(ti18n, "DETAILS"));
                detailsParamView.render();
                //paramViewArray.push(detailsParamView);
                const searchedElementCategoryParamView =  new WordParamView();
                searchedElementCategoryParamView.setLabel(window.getI18n(ti18n, "SEARCHED_TYPE") +": ");
                searchedElementCategoryParamView.setValue(deletionSource.getIsCustomType()?deletionSource.getCustomTypeLabel(): this.getSearchQueryPresetTypeLabel(deletionSource.getSearchedElementCategory()));
                searchedElementCategoryParamView.render();
                paramViewArray.push(searchedElementCategoryParamView);
                
                const streamlinedConfidenceView =  new WordParamView();
                streamlinedConfidenceView.setLabel(window.getI18n(ti18n, "CONFIDENCE") +": ");
                streamlinedConfidenceView.setValue(this.getSearchResultConfidenceLevelLabel(deletionSource.getStreamlinedSuggestionConfidence()));
                streamlinedConfidenceView.render();
                paramViewArray.push(streamlinedConfidenceView);

                if(false){
                const confidenceView =  new WordParamView();
                confidenceView.setLabel(window.getI18n(ti18n, "CONFIDENCE") +": ");
                confidenceView.setValue(this.getSearchResultConfidenceLevelLabel(deletionSource.getConfidence()));
                confidenceView.render();
                paramViewArray.push(confidenceView);
                }

                if(deletionSource.getRecommendation() && false){
                    const recommendationParamView =  new WordParamView();
                    recommendationParamView.setLabel(window.getI18n(ti18n, "RECOMMENDATION") +": ");
                    recommendationParamView.setValue(this.getSearchQueryPresetTypeLabel(deletionSource.getRecommendation()));
                    recommendationParamView.render();
                    paramViewArray.push(recommendationParamView);
                }

                const reasonParamView =  new ParagraphParamView();
                reasonParamView.setLabel(window.getI18n(ti18n, "REASON") +": ");
                reasonParamView.setValue(Utils.getInstance().removeWordIdsFromTranscription(deletionSource.getReason()));
                reasonParamView.render();
                paramViewArray.push(reasonParamView);

            }
            if(this.getSequencerNode().getDeletionSource().getType() === Utils.getInstance().getDeletionSourceType().TEXT_SEARCH){
                const keywordSearchedParamView =  new WordParamView();
                keywordSearchedParamView.setLabel(window.getI18n(ti18n, "KEYWORD_SEARCHED") +": ");
                keywordSearchedParamView.setValue(deletionSource.getKeywordSearch());
                keywordSearchedParamView.render();
                paramViewArray.push(keywordSearchedParamView);
            }
        }else{
            const numberOfElementsDeleted = this.getSequencerNode() && this.getSequencerNode().getArrayOfNodeReplaced() &&  this.getSequencerNode().getArrayOfNodeReplaced().length;
            const infoBoxView =  new InfoBoxView({
                "iconClass" :"soundwave-multi-select",
                "message" : `${numberOfElementsDeleted} ${numberOfElementsDeleted === 1?window.getI18n(ti18n, "ELEMENT_DELETED"):window.getI18n(ti18n, "ELEMENTS_DELETED")}`,
            });

            infoBoxView.render();
            paramViewArray.push(infoBoxView);

        }
        return paramViewArray;
    }


});
export default DeletedSequencerNodeInspectorView;
